import {personal_sub_menu} from "./personalSubHeader"
import {explore_menu_data} from "./exploreHeader"
import {business_menu_data} from "./businessHeader"

export const main_header_menu = [
    {
      id: 1,
      labels: "Personal",
      menu: personal_sub_menu,
      url: `${process.env.Telecel_web_url}/`,
    },
    {
      id: 2,
      labels: "Business",
      menu: business_menu_data,
      url: `${process.env.Telecel_web_url}/business/`,
    },
    {
      id: 3,
      labels: "Explore",
      menu: explore_menu_data,
      url: `${process.env.Telecel_web_url}/explore-telecel/`,
    },
  ]


